var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("van-pull-refresh", {
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_c("div", {
    staticClass: "blue-tooth"
  }, [_c("div", {
    staticClass: "left",
    on: {
      click: _vm.toVehicleManagement
    }
  }, [_c("span", [_vm._v("MG iSmart")]), _c("img", {
    staticClass: "switch",
    attrs: {
      src: require("../assets/images/Switch.png"),
      alt: ""
    }
  })]), _c("img", {
    staticClass: "right",
    attrs: {
      src: require("../assets/images/BT.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "content"
  }, [_c("div", {
    staticClass: "km"
  }, [_c("span", {
    staticClass: "num"
  }, [_vm._v("628")]), _c("div", {
    staticClass: "unit"
  }, [_c("span"), _c("span", [_vm._v("Km")])])]), _c("div", {
    staticClass: "total-range"
  }, [_vm._v("Total Range")]), _c("div", {
    on: {
      click: _vm.toVehicleManagement
    }
  }, [_c("img", {
    staticClass: "car",
    attrs: {
      src: require("../assets/images/car.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "position"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/position.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v("No.8 Songnan Third Village, Baoshan District")])]), _c("div", {
    staticClass: "card"
  }, [_c("div", {
    staticClass: "battery box"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Battery")]), _c("div", {
    staticClass: "num"
  }, [_c("span", [_vm._v(_vm._s(_vm.batteryNum))]), _c("span", {
    staticClass: "percent"
  }, [_vm._v("%")])]), _c("div", {
    staticClass: "pic"
  }, [_c("span", {
    style: "width:" + _vm.width + "px;"
  })])]), _c("div", {
    staticClass: "temperature box"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Temperature")]), _c("div", {
    staticClass: "num"
  }, [_c("span", [_vm._v("23")]), _c("span", [_vm._v("°")])]), _c("div", {
    staticClass: "dscb"
  }, [_vm._v("On Int.28℃")])])]), _c("div", {
    staticClass: "card1"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/lock.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Lock")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/window.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Window")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Tail Gate.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Tail Gate")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/findCar.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Find Car")])])]), _c("div", {
    staticClass: "card2"
  }, [_c("div", {
    staticClass: "title"
  }, [_vm._v("Owner services")]), _c("div", {
    staticClass: "top"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/EV.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("EV")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Geo Fence.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Fence")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Vehicle State.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Vehicle")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Digital Key.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Digital Key")])])]), _c("div", {
    staticClass: "bottom"
  }, [_c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/MG Touchpoint.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Touchpoint")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Smart Drive.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Smart Drive")])]), _c("div", {
    staticClass: "item"
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/Remote diagnosis.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Diagnosis")])]), _c("div", {
    staticClass: "item",
    staticStyle: {
      visibility: "hidden"
    }
  }, [_c("img", {
    staticClass: "img",
    attrs: {
      src: require("../assets/images/MG Touchpoint.png"),
      alt: ""
    }
  }), _c("span", [_vm._v("Touchpoint")])])])])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };